import CapacityEquipment from './Constructor'

export default CapacityEquipment
export { CapacityEquipment }
